import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { MapPin, Navigation, Users, ShieldCheck, Truck } from "lucide-react";
export default function PacificNorthwestLocalServiceHero() {
  const features = [{
    icon: MapPin,
    text: "זמינות מיידית בחיפה"
  }, {
    icon: Navigation,
    text: "כיסוי מלא בקריות"
  }, {
    icon: Users,
    text: "ליווי אישי בבית הלקוח"
  }, {
    icon: ShieldCheck,
    text: "פיקוח מקצועי צמוד"
  }];
  return <section data-section-id="261069" id="מטפל-סיעודי-בחיפה-פתרון-מיידי" className="relative bg-background text-foreground overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-accent/30 via-background to-background opacity-50 pointer-events-none" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-8 items-center">
          
          {}
          <div className="flex flex-col gap-8 max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-primary/20 w-fit">
              <MapPin className="size-4 text-primary" />
              <span className="text-sm font-default font-medium tracking-wide text-primary uppercase">שירות סיעודי מקומי בחיפה</span>
            </div>
            
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-default font-bold tracking-tight text-foreground leading-tight">
              מטפל סיעודי בחיפה תוך 5 שעות
            </h1>
            
            <p className="text-lg sm:text-xl text-muted-foreground font-default leading-relaxed">
              חברת <Link to="/" className="text-primary font-bold hover:underline">Siudy – סיעוד מיידי</Link> מספקת מענה מהיר ומקצועי לתושבי חיפה והסביבה. בין אם אתם זקוקים לשירותי <Link to="/CaregiverServicePagesPage" className="text-primary underline hover:text-primary/80">מטפל סיעודי בבית</Link> או מחפשים <Link to="/CaregiverServicePagesPage2" className="text-primary underline hover:text-primary/80">השגחה בבית חולים</Link> בחיפה, הצוות שלנו ערוך להגיע אליכם תוך שעות ספורות. אנו מבינים את הדחיפות במצבים סיעודיים ומחויבים לשירות איכותי, אמין ומהיר בכל רחבי העיר. השירות שלנו זמין גם עבור <Link to="/NursingCaregiverInTelAvivWithinFiveHoursPage" className="text-primary underline hover:text-primary/80">מטפל סיעודי בתל אביב</Link>, <Link to="/NursingCareProviderInJerusalemWithinFiveHoursPage" className="text-primary underline hover:text-primary/80">מטפל סיעודי בירושלים</Link> וכן <Link to="/NursingCareInRamatGanWithinHoursPage" className="text-primary underline hover:text-primary/80">מטפל סיעודי בבית</Link> ברמת גן. למידע נוסף על זכויותיכם, מומלץ לקרוא ב<Link to="/ProfessionalBlogPage" className="text-primary underline hover:text-primary/80">בלוג המקצועי</Link> שלנו.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-2">
              {features.map((feature, i) => <div key={i} data-index={i} className="flex items-center gap-3 bg-card p-3 rounded-lg border border-border shadow-sm">
                  <div className="bg-primary/10 p-2 rounded-md">
                    <feature.icon className="size-5 text-primary" />
                  </div>
                  <span className="font-medium text-foreground font-default">{feature.text}</span>
                </div>)}
            </div>

            <div className="pt-6 flex flex-col sm:flex-row gap-4">
              <Button variant="secondary" size="lg" className="bg-secondary text-secondary-foreground font-default font-bold text-base h-12 px-8 shadow-md hover:opacity-90" asChild>
                <Link to="/ContactPage">דברו איתנו עכשיו</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full h-full min-h-[400px] lg:min-h-[500px] rounded-lg overflow-hidden shadow-xl border border-border">
            <div className="absolute inset-0 bg-primary/5 mix-blend-overlay z-10" />
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/haifa_nursing_care_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/haifa_nursing_care_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1626204/img/haifa_nursing_care_hero.png-wvc-sizes" alt="מטפל סיעודי בחיפה והסביבה" className="absolute inset-0 w-full h-full object-cover object-center" loading="eager" />
            {}
            <div className="absolute bottom-6 left-6 right-6 z-20 bg-card/90 backdrop-blur-md border border-border p-6 rounded-lg shadow-lg">
              <div className="flex items-start gap-4">
                <div className="bg-primary p-3 rounded-md shrink-0">
                  <Truck className="size-6 text-primary-foreground" />
                </div>
                <div>
                  <h3 className="text-lg font-default font-bold text-foreground mb-1">מענה מהיר בחיפה</h3>
                  <p className="text-sm text-muted-foreground font-default">מגיעים לכל שכונות חיפה והקריות עם צוות מטפלים מוסמך ומנוסה.</p>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </section>;
}